import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core"
import React from "react"
import { Link } from "react-router-dom"

import { isNavItemActive } from "./navItemActive"

function NavListItem({ to, icon: Icon, label, size, titleAccess, alwaysShowText, pathname, match, isActive }) {
  const tooltip = titleAccess ?? label
  const showText = alwaysShowText || size === "full"
  const selected = pathname ? isNavItemActive(pathname, { to, match, isActive }) : false

  return (
    <ListItem button component={Link} to={to} selected={selected}>
      <ListItemIcon>
        <Icon titleAccess={size === "full" ? "" : tooltip} />
      </ListItemIcon>
      {showText && <ListItemText primary={label} />}
    </ListItem>
  )
}

export default NavListItem
